import { useState } from 'react';
import { Col, Row, Steps } from 'antd';

import { I18nt } from 'utils';
import Container from 'components/Container';
import { CalendarFilled } from '@ant-design/icons';
import styles from './stepper.module.less';
import BannerWithImage from 'components/BannerWithImage';

//steps
import PlaceView from '../PlaceView';
import DateView from '../DateView';
import Confirm from '../Confirm';
import CategoryView from '../CategoryView';
import DoctorView from '../DoctorView';
import DoctorDateView from '../DoctorDateView';
import { useAgendarCita } from 'pages/AgendarCita/AgendarCitaContext';

const { Step } = Steps;

const getSteps = (isSpecialist = false) => {
  if (isSpecialist) {
    return [
      { title: 'Especialidad', content: <CategoryView /> },
      { title: 'Médicos', content: <DoctorView /> },
      { title: 'Fecha y hora', content: <DoctorDateView /> },
      { title: 'Confirmar', content: <Confirm /> },
    ];
  }
  return [
    { title: 'Lugar', content: <PlaceView /> },
    { title: 'Fecha y hora', content: <DateView /> },
    { title: 'Confirmar', content: <Confirm /> },
  ];
};

function StepperView() {
  const [current, setCurrent] = useState(0);
  const {
    selectedTime,
    selectedDate,
    selectedClinic,
    selectedCategory,
    setShowConfirmarCita,
    patient,
    isSpecialist,
    selectedDoctor,
    phone
  } = useAgendarCita();

  const steps = getSteps(isSpecialist);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const isDisabledConfirmBtn = isSpecialist && phone.length < 9;

  const enableNextBtn = () => {
    if (isSpecialist) {
      const validationsSpecialist: { [key: string]: boolean } = {
        [0]: Boolean(!selectedCategory),
        [1]: Boolean(!selectedDoctor),
        [2]: Boolean(!selectedDate || !selectedTime),
      };
      return validationsSpecialist[current];
    }
    const validations: { [key: string]: boolean } = {
      [0]: Boolean(!selectedClinic),
      [1]: Boolean(!selectedDate || !selectedTime),
    };
    return validations[current];
  };

  return (
    <section className={styles.stepperPage}>
      <BannerWithImage>
        <section className={styles.section}>

          <Container className={styles.headerContainer}>
            <Row justify='center'>
              <Col xs={24} lg={18} xl={14} xxl={12}>
                <h2>{I18nt(isSpecialist ? 'cita_especialista' : 'calendariza_3_pasos')}</h2>
                {current < steps.length - 1 && (
                  <div className={styles.patientName}>
                    <CalendarFilled style={{ fontSize: '19px' }} />
                    <p>{`${I18nt('calanderiza_para')} ${patient?.nombrePaciente
                      } ${patient?.apellidoPaciente}`}</p>
                  </div>
                )}
                <p>
                  {I18nt(isSpecialist ? 'description_especialidad' : 'descripcion_calanderiza')}
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section className={styles.stepsSection}>
          <Container className='isbm-steps'>
            <Row justify='center'>
              <Col xs={24} lg={10}>
                <Steps
                  responsive={false}
                  current={current}
                  percent={60}
                  size='small'
                  type='navigation'
                >
                  {steps.map((item) => (
                    <Step
                      key={item.title}
                      title={item.title}
                      className={styles.stepCont}
                    />
                  ))}
                </Steps>
              </Col>
            </Row>
            <Row>
              <Col xs={24}>
                <div>{steps[current].content}</div>
              </Col>
            </Row>
            <Row justify='center' className={styles.stepsAction}>
              <Col xs={12} lg={6}>
                <div className={styles.prevCont}>
                  {current > 0 && (
                    <button className={styles.prev} onClick={() => prev()}>
                      {I18nt('regresar')}
                    </button>
                  )}
                </div>
              </Col>
              <Col xs={12} lg={6}>
                {current < steps.length - 1 && (
                  <button
                    disabled={enableNextBtn()}
                    className={styles.next}
                    onClick={() => next()}
                  >
                    {I18nt('continuar')}
                  </button>
                )}
                {current === steps.length - 1 && (
                  <button
                    disabled={isDisabledConfirmBtn}
                    className={styles.next}
                    onClick={() => setShowConfirmarCita(true)}
                  >
                    {I18nt('confirmar_cita')}
                  </button>
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </BannerWithImage>
    </section>
  );
}

export default StepperView;
